module.exports = __webpack_public_path__ + "img/skate-quiz-pair-female.ecb6edd1.png";